import React, { ReactChildren, ReactChild } from 'react';
import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '14px',
  },
  border: {
    borderBottom: '1px solid #E6E9EE',
    width: '100%',
  },
  content: {
    padding: '0 34px',
    marginBottom: 0,
  },
}));

interface AuxProps {
  children: ReactChild | ReactChildren;
}

const DividerWithText = ({ children }: AuxProps) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.border} />
      <Typography variant="body1" className={classes.content}>
        {children}
      </Typography>
      <div className={classes.border} />
    </div>
  );
};
export default DividerWithText;
